import React, { useState } from "react";
import "./ManualDepositPopup.css";
import QrManualDeposit from "./QrManualDeposit"; // Import the QR popup
import { IoChevronBackSharp } from "react-icons/io5";
import Storage from "../../../Storage";

function WithdrawBank({ isOpen, onClose }) {
  const [amount, setAmount] = useState("");
  const [qrManualDepositVisible, setQrManualDepositVisible] = useState(false);

  if (!isOpen) return null;

  return (
    <div className="popup-overlay-inner-main-543">
      <div className="popup-container-inner-main-543">
        <div className="vip2-popup-page" style={{ background: "#323738" }}>
          <div className="vip2-popup-page-btn" onClick={onClose}>
            <IoChevronBackSharp />
          </div>
          Online Withdraw
        </div>
        <div
          className="main-int-overflow-sroll"
          style={{
            padding: "20px",
            background: "#232626",
            borderRadius: "0px 0px 10px 10px ",
          }}
        >
          <div
            style={{
              background: "#323738",
              padding: "20px",
              borderRadius: "10px",
            }}
          >
            <div style={{ marginBottom: "20px" }} className="main-int-uew-1235">
              <div className="main-int-uew-1236">Deposit Currency</div>
              <div className="main-int-uew-1237">
                <img
                  className="main-int-uew-1238"
                  src="/assets/bcimages/USDT.png"
                  alt="USDT"
                />
                <div>{Storage?.getKey("currency")}</div>
              </div>
            </div>
            <div className="main-int-uew-new-1">Online Withdraw</div>
            <div className="popup-body-inner-main-543">
              <div
                style={{ textAlign: "start" }}
                className="amount-input-inner-main-543"
              >
                <img style={{ width: "60px" }} src="/assets/images/USDT.png" />
              </div>
            </div>

            {/* <div
              style={{
                margin: "20px 0px",
                background: "#514634",
                display: "flex",
                alignItems: "center",
                gap: "5px",
                borderRadius: "10px",
              }}
            >
              <img
                style={{ width: "50px" }}
                src="/assets/images/bonus-gift.webp"
              />
              <div style={{ fontWeight: "bold", textAlign: "start" }}>
                Get extra <span style={{ color: "#FF9820" }}>180%</span> bonus
                on minimum of{" "}
                <span style={{ color: "#FF9820" }}>$1,056.84</span> deposit
              </div>
            </div> */}

            <div className="main-int-uew-new-1">Amount</div>

            <div className="popup-body-inner-main-543">
              <input
                className="amount-input-inner-main-543"
                type="number"
                placeholder="Enter Amount"
                value={amount}
                onChange={(e) => setAmount(e.target.value)}
              />
            </div>
            <div className="main-int-uew-new-1">Bank Name</div>

            <div className="popup-body-inner-main-543">
              <input
                className="amount-input-inner-main-543"
                type="number"
                placeholder="Enter Bank Name"
                value={amount}
                onChange={(e) => setAmount(e.target.value)}
              />
            </div>
            <div className="main-int-uew-new-1">Account Name:</div>

            <div className="popup-body-inner-main-543">
              <input
                className="amount-input-inner-main-543"
                type="number"
                placeholder="Enter Account Number"
                value={amount}
                onChange={(e) => setAmount(e.target.value)}
              />
            </div>
            <div className="main-int-uew-new-1">IFSC Code:</div>

            <div className="popup-body-inner-main-543">
              <input
                className="amount-input-inner-main-543"
                type="number"
                placeholder="Enter IFSC Code"
                value={amount}
                onChange={(e) => setAmount(e.target.value)}
              />
              <button
                className="submit-button-inner-main-543"
                // onClick={handleSubmit}
              >
                Submit Withdraw
              </button>
            </div>

            <div
              className="deposit-rules-text-12"
              style={{ background: "#314940", color: "#B3BEC1" }}
            >
              <div>
                1. Your transfer amount has to MATCH the submission amount.
              </div>
              <div>
                2. Each Order ID can ONLY be used once to avoid duplicates.
              </div>
              <div>
                3. Please follow the deposit guideline to make deposit,
                otherwise your deposit will be missing.
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Show the QR popup */}
      <QrManualDeposit
        isOpen={qrManualDepositVisible}
        onClose={() => setQrManualDepositVisible(false)}
      />
    </div>
  );
}

export default WithdrawBank;
